import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducer/root-reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

const composeEnhancers = composeWithDevTools(applyMiddleware(thunk));

export default function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, composeEnhancers);
}